import { IEmployeeDetailRaw, TEmployeeStatus } from '../../../services/Employee/types'
import { EMPTY_FORM, formFromDraft, IAdmissionForm, stepFormData } from '../Admission/admissionForm'

/** The admission form's fields plus what only RH sets: role, sector and the dates. */
export interface IEmployeeForm extends IAdmissionForm {
  job_position_id: number | null
  sector_id: number | null
  admission_date: string
  termination_date: string
}

export const EMPTY_EMPLOYEE_FORM: IEmployeeForm = {
  ...EMPTY_FORM,
  job_position_id: null,
  sector_id: null,
  admission_date: '',
  termination_date: ''
}

export const employeeFormFromDetail = (detail: IEmployeeDetailRaw): IEmployeeForm => ({
  ...formFromDraft({
    ...detail,
    photo_url: detail.photo_url,
    job_requisition_id: null,
    username: detail.username,
    benefit_accepted: false,
    benefit_accepted_at: null
  }),
  job_position_id: detail.job_position?.id ?? null,
  sector_id: detail.sector_id,
  admission_date: detail.admission_date ?? '',
  termination_date: detail.termination_date ?? ''
})

/**
 * Everything the panel sends, built with the admission form's own serializers so both write the
 * same shape. The dates go only where the status has them.
 */
export const employeeFormData = (form: IEmployeeForm, photo: File | null, status: TEmployeeStatus): FormData => {
  const data = new FormData()

  // The routes go only with the transport voucher: stale ones would fail validation on a hidden tab.
  const steps = form.transport_benefits.includes('transport_voucher') ? ([1, 3, 4, 5] as const) : ([1, 3, 4] as const)
  for (const step of steps) {
    stepFormData(step, form, step === 1 ? photo : null).forEach((value, key) => {
      if (key !== 'step' && key !== 'benefit_accepted') data.append(key, value)
    })
  }

  data.append('job_position_id', form.job_position_id ? String(form.job_position_id) : '')
  data.append('sector_id', form.sector_id ? String(form.sector_id) : '')
  data.append('username', form.username)
  if (status !== 'pending') data.append('admission_date', form.admission_date)
  if (status === 'inactive') data.append('termination_date', form.termination_date)

  return data
}
